import { render } from "./LiveWideList.vue?vue&type=template&id=22f1372a&scoped=true"
import script from "./LiveWideList.vue?vue&type=script&lang=js"
export * from "./LiveWideList.vue?vue&type=script&lang=js"

import "./LiveWideList.vue?vue&type=style&index=0&id=22f1372a&scoped=true&lang=css"

import exportComponent from "D:\\dev\\mdm-crtwww-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22f1372a"]])

export default __exports__